import { tabStyle as style } from './tabs.style';
import { Icon } from '@/components/icons/svg-icons';

interface TabsProps {
	children: React.ReactNode,
}

export const Tabs = ({
	children,
}: TabsProps) => {
	return (
		<div data-name="tabs" className={style.tabs}>
			{children}
		</div>
	)
}

interface TabProps {
	label: string,
	isSelected: boolean,
	onClick: () => void,
	iconName?: string,
}

export const Tab = ({
	label,
	isSelected,
	onClick,
	iconName = '',
}: TabProps) => {
	return (
		<div
			data-name="tab"
			className={style.tab}
			data-active={isSelected ? true : undefined}
			onClick={onClick}
		>
			{iconName !== '' ? <Icon name={iconName} /> : null}
			{label}
		</div>
	)
}